import React from 'react';
import { Modal } from 'react-bootstrap-5';

import { updateContact } from 'bundles/connect/components/store/actions/owners';
import { connect } from 'react-redux';
import ContactForm from '../../contacts/form/contact_form';
import type { Contact } from 'bundles/connect/types';

type Props = {
  initialContact: Contact;
  show?: boolean;
  updateContact: (id: number, contact: Contact) => Promise<void>;
  onHide: () => void;
}

export function EditModal({ initialContact, show, onHide, updateContact }: Props) {
  const handleUpdate = ({ contact }) => {
    updateContact(contact.id, contact).then(() => {
      onHide();
    });
  };

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header className="flex-row" closeButton>
        <Modal.Title>Edit Contact</Modal.Title>
      </Modal.Header>
      <ContactForm
        initialContact={initialContact}
        type={initialContact.type}
        onCancel={onHide}
        onSave={handleUpdate}
      />
    </Modal>
  );
}

export default connect(null, { updateContact })(EditModal);
